var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'school': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/school.js